import { ApiConfig } from '../../../../config/ApiConfig';
import { createRequestActionTypes } from '../../../../utils/request-actions-helpers/createRequestActionTypes';
import { FetchRequestActions } from '../../../../utils/request-actions-helpers/createRequestActions';
import { RequestThunkParameters, createRequestThunk } from '../../../../utils/request-actions-helpers/createRequestThunk';

export interface Cloudfront {
    ip: string
    signedImages: string
    signedFiles: string
}

export interface CloudfrontResponse {
    ip: string
    signed: string
    signedFiles: string
}

export const fetchCloudfrontActionTypes = createRequestActionTypes('CLOUDFRONT')

export type CloudfrontActions = FetchRequestActions<Cloudfront>

export const fetchCloudfront = (config: ApiConfig) => {
    const thunkParams: RequestThunkParameters<Cloudfront> = {
        method: 'GET',
        requestActionTypes: fetchCloudfrontActionTypes,
        url: `${config.API_URL}/files/domainsignedurl`,
        processResultBeforeDispatch: (x: CloudfrontResponse): Cloudfront => ({
            ip: x.ip,
            signedFiles: x.signedFiles,
            signedImages: x.signed
        })
    }
    return createRequestThunk(thunkParams)
}